import { Storefront, Confetti, MaskHappy, MusicNotes, UsersFour, SoccerBall, ForkKnife, Sparkle } from 'phosphor-react';
import type { IconKey } from '@/constants/categories';

interface Props { kind: IconKey; size?: number; weight?: 'regular' | 'fill' | 'bold' | 'duotone' | 'thin'; className?: string }

const PH: Partial<Record<IconKey, any>> = {
  storefront: Storefront, confetti: Confetti, mask: MaskHappy, music: MusicNotes,
  family: UsersFour, soccer: SoccerBall, fork: ForkKnife, sparkle: Sparkle,
};

function Tent({ size = 24, color = 'currentColor' }: any) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 20h18" /><path d="M12 4l-9 16" /><path d="M12 4l9 16" /><path d="M12 14l-3 6" /><path d="M12 14l3 6" /><path d="M12 4v10" />
  </svg>;
}
function FerrisWheel({ size = 24, color = 'currentColor' }: any) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="11" r="8" /><circle cx="12" cy="11" r="1.4" fill={color} />
    <path d="M12 3v16" /><path d="M4 11h16" /><path d="M6.3 5.3l11.4 11.4" /><path d="M17.7 5.3L6.3 16.7" />
    <path d="M9 21h6" /><path d="M11 19l-2 2M13 19l2 2" />
  </svg>;
}
function Fireworks({ size = 24, color = 'currentColor' }: any) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round">
    <circle cx="12" cy="12" r="1.2" fill={color} />
    <path d="M12 4v3M12 17v3M4 12h3M17 12h3M6.3 6.3l2.1 2.1M15.6 15.6l2.1 2.1M17.7 6.3l-2.1 2.1M8.4 15.6l-2.1 2.1" />
    <circle cx="12" cy="12" r="6" strokeDasharray="2 3" />
  </svg>;
}
function FairRide({ size = 24, color = 'currentColor' }: any) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9h18l-2 4H5L3 9z" /><path d="M3 9l3-5h12l3 5" /><path d="M5 13v7" /><path d="M19 13v7" /><path d="M9 13v7M15 13v7" />
  </svg>;
}

function RacingWheel({ size = 24, color = 'currentColor' }: any) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9" />
    <circle cx="12" cy="12" r="3" />
    <path d="M12 9V4" /><path d="M9 10.5L4.8 7.5" /><path d="M9 13.5L4.8 16.5" />
    <path d="M12 15v5" /><path d="M15 13.5L19.2 16.5" /><path d="M15 10.5L19.2 7.5" />
  </svg>;
}

const CUSTOM: Partial<Record<IconKey, any>> = { tent: Tent, wheel: FerrisWheel, fireworks: Fireworks, fair: FairRide, car: RacingWheel };

export function CatIcon({ kind, size = 24, weight = 'regular', className }: Props) {
  const Phi = PH[kind];
  if (Phi) return <Phi size={size} weight={weight} className={className} />;
  const C = CUSTOM[kind] ?? Sparkle;
  return <C size={size} className={className} />;
}
